import { Component, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from '../services/http.service';
import { URLUtils } from '../urlUtils';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription, interval, take } from 'rxjs';
import { es } from 'date-fns/locale';
import { ensureActiveSubscription } from '../shared/subscription-dialog';
import { ModalService } from '../model/model.service';
import { ConfirmDialogComponent } from 'src/app/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SuccessDialogComponent } from 'src/app/success-dialog/success-dialog.component';
import { ConfirmPlanComponent } from 'src/app/confirm-plan/confirm-plan.component';

@Component({
    selector: 'app-invoice',
    templateUrl: './invoice.component.html',
    styleUrls: ['./invoice.component.scss'],
    standalone: false
})
export class InvoiceComponent {

  @Output() event = new EventEmitter<string>();
  selectedValue: string = "view";
  //selectedMatter: string = "legalmatter";
  changeStatusModel: boolean = false;
  selectedInvoice: any;
  successMessage: string = '';
  isDelete: boolean = false;

  isDisplay: boolean = true;
  searchText: any = '';
  searchValue:string = '';
  invoicelist: any[] = [];
  is_invoice: boolean = false;
  invid: any;
  errorMsg: boolean = false;
  successModel: boolean = false;
  successModalOpen: boolean = false;
  invoice_id: any;
  invoice: any;
  profile: any;
  message: string = '';
  docsSharedwithus: any;
  @Input() docsSharedbyus: any = [];
  sharedandUnsharedData: any = { 'add': [], 'remove': [], 'message': "" };
  @Input() reldata: any = {};
  profileInfo: any;
  invoice_data: any;
  isChecked: any;
  isReverse:boolean=false;
  sortKey: string = '';
  invoice_message: any;
  private autoRefreshSub!: Subscription;
  currentPage = 1;
  itemsPerPage = 10;
    
  getPlan:any;
  getCategory:any;
  restrictedPlans = ['free', 'professional', 'starter'];

  constructor(private router: Router, private toast: ToastrService, private dialog: MatDialog, private spinnerService: NgxSpinnerService, private route: ActivatedRoute, private httpservice: HttpService, private confirmationDialogService: ConfirmationDialogService, private modalService: ModalService) { }

  ngOnInit() {
    this.getInvoiceList();
    this.getProfile();
    
    this.getPlan = localStorage.getItem("plan"); // get current plan
    this.getCategory = localStorage.getItem("category"); // get current category

    // this.autoRefreshSub = interval(5000).subscribe(() => {
    //   this.getInvoices();
    // });
    this.autoRefreshSub = interval(5000)
      .pipe(take(1))
      .subscribe(() => {
        this.getInvoices();
    });
  }

  ngOnDestroy(): void {
    if (this.autoRefreshSub) {
      this.autoRefreshSub.unsubscribe();
    }
  }

  getInvoices() {
    this.httpservice.sendGetRequest(URLUtils.Invoice).subscribe((res: any) => {
      this.invoicelist = res?.data;
    });
  }
  
  sendInvoice() {
    let data = {
      "add": [{
        "docid": this.invoice_data.docid,
        "doctype": "general",
        "matters": []
      }],
      "message": this.invoice_message || "",
      "remove": []
    };

    let corpData = {
      "add": [{
        "docid": this.invoice_data.docid,
        "doctype": "general",
        "matters": []
      }],
      "message": this.invoice_message || "",
      "remove": [],
      "relid": this.invoice_data.rel_id,
    };

    const params = { module: 'invoice' };

    if (this.invoice_data.client_type !== 'corporate') {
      this.httpservice.sendPutRequest(URLUtils.shareInvoiceDocuments(this.invoice_data.rel_id), data, params).subscribe((res: any) => {
        if (!res.error) {
          this.toast.success("Invoice Shared Successfully!!");
          this.successModel = false;
          this.confirmationDialogService.confirm('Success',
            'Congratulations!! You have successfully shared Invoice ' + this.invoice.name, false, '', '', false, "sm", false)
            .then(() => { });
          this.event.emit('exchange-close');
        } else {
          this.toast.error(res.msg);
        }
      });
    }

    if (this.invoice_data.client_type === 'corporate') {
      this.httpservice.sendPostRequest(URLUtils.shareRelationshipDocumentsCorp, corpData, params).subscribe((res: any) => {
        if (!res.error) {
          this.toast.success("Invoice Shared Successfully!!");
          this.successModel = false;
          this.confirmationDialogService.confirm('Success',
            'Congratulations!! You have successfully shared Invoice ' + this.invoice.name, false, '', '', false, "sm", false)
            .then(() => { });
          this.event.emit('exchange-close');
        } else {
          this.toast.error(res.msg);
        }
      });
    }
  }

  getProfile() {
    this.httpservice.sendGetRequest(URLUtils.profile).subscribe(
      (res: any) => {
        if (res.error == false) {
          this.profile = res.data?.details;
        }
      });
  }

  getInvoiceList() {
    this.spinnerService.show();
    this.httpservice.sendGetRequest(URLUtils.Invoice).subscribe((res: any) => {
      this.spinnerService.hide();
      if (!res.error) {
        this.invoicelist = res?.data;
        this.errorMsg = this.invoicelist.length == 0 ? true : false;
      } else {
        this.toast.error(res.msg);
      }
    });
  }
  get paginatedInvoices() {
  const filtered = this.searchText
    ? this.invoicelist.filter(i =>
        JSON.stringify(i).toLowerCase().includes(this.searchText.toLowerCase())
      )
    : this.invoicelist;

  const start = (this.currentPage - 1) * this.itemsPerPage;
  return filtered.slice(start, start + this.itemsPerPage);
}

get totalPages(): number {
  const totalItems = this.searchText
    ? this.invoicelist.filter(i =>
        JSON.stringify(i).toLowerCase().includes(this.searchText.toLowerCase())
      ).length
    : this.invoicelist.length;

  return Math.ceil(totalItems / this.itemsPerPage);
}

 
prev() {
  if (this.currentPage > 1) {
    this.currentPage--;
  }
}

next() {
  if (this.currentPage < this.totalPages) {
    this.currentPage++;
  }
}

  //subscription check for action button
  checkPlan(event?: MouseEvent): boolean {
    const restrictedPlans = ['free', 'professional', 'starter'];

    if (restrictedPlans.includes(this.getPlan)) {
      this.dialog.open(ConfirmPlanComponent, {
        width: '400px',
        data: { plan: this.getPlan }
      });

      return false;   // Stop further execution
    }
    return true;      // Allow further execution
  }

   isRestrictedPlan(): boolean {
    return this.restrictedPlans.includes((this.getPlan || '').trim().toLowerCase());
  }

  createInvoice() {
    if (!ensureActiveSubscription(this.confirmationDialogService)) { 
      return; 
    }
    if (!this.checkPlan()) {
      return;
    } // Stop here if plan is restricted

    this.router.navigate(['/createinvoice']);
  }

  viewdetails(item: any) {
    this.invid = item.id;
    this.router.navigate(['/preview', this.invid]);
  }
  editInvoice(item: any) {
    this.invid = item.id;
    this.router.navigate(['/createinvoice'], { queryParams: { id: this.invid } });
  }

  delete(invid: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { title: 'Confirmation', message: `Are you sure do you want to delete this Invoice?` }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      //console.log('Dialog result:', result);
      if (result) {
        this.spinnerService.show();
        this.httpservice.sendDeleteRequest(URLUtils.InvoiceWithId(invid)).subscribe((res: any) => {
          this.spinnerService.hide();

          if (res.error === false) {
            this.toast.success(res.msg);
            // this.isDelete = true;
            // this.successMessage = res.msg || 'Invoice deleted successfully.';
            // this.successModalOpen = true;
            // this.modalService.open('custom-modal-1');
            this.getInvoiceList();
          } else {
            this.toast.error(res.msg);
          }
        },
          (error: HttpErrorResponse) => {
            if (error.status === 401 || error.status === 403) {
              const errorMessage = error.error.msg || 'Unauthorized';
              this.toast.error(errorMessage);
            }
          });
      }
    });

    // this.confirmationDialogService.confirm('Confirmation', 'Are you sure do you want to delete this Invoice?', true, 'Yes', 'No')
    //   .then((confirmed) => {
    //     if (confirmed) {
    //       this.spinnerService.show();
    //       this.httpservice.sendDeleteRequest(URLUtils.InvoiceWithId(invid)).subscribe((res: any) => {
    //         this.spinnerService.hide();

    //         if (res.error === false) { 
    //            this.isDelete = true;
    //             this.successMessage = res.msg || 'Invoice deleted successfully.';
    //             this.successModalOpen = true;
    //             this.modalService.open('custom-modal-1');

    //             this.getInvoiceList();
    //         } else {
    //           this.toast.error(res.msg);
    //         }
    //       },
    //       (error: HttpErrorResponse) => {
    //         if (error.status === 401 || error.status === 403) {
    //           const errorMessage = error.error.msg || 'Unauthorized';
    //           this.toast.error(errorMessage);
    //         }
    //       });
    //     }
    //   });
  }

  closeModal(id: string) {
  this.modalService.close(id);
  this.successModalOpen = false; 
}

  onSub(item: any) {
    this.successModel = true;
    this.invid = item.id;
    this.invoice_data = item;
    this.invoice_message = '';
  }

  btnclose() {
    this.successModel = false;
  }

  onKeydown(event: any) {
  }

  sortingFile(val: any) {
    this.isReverse = !this.isReverse;
    if (this.isReverse) {
      this.invoicelist = this.invoicelist?.sort((p1: any, p2: any) => (p1[val] < p2[val]) ? 1 : (p1[val] > p2[val]) ? -1 : 0);
    } else {
      this.invoicelist = this.invoicelist?.sort((p1: any, p2: any) => (p1[val] > p2[val]) ? 1 : (p1[val] < p2[val]) ? -1 : 0);
    }
  }

  sortingDateFile(val: string) {
    if (this.sortKey === val) {
      this.isReverse = !this.isReverse;
    } else {
      this.sortKey = val;
      this.isReverse = false;
    }
    
    this.invoicelist = this.invoicelist?.sort((p1: any, p2: any) => {
      const date1 = new Date(p1[val]);
      const date2 = new Date(p2[val]);
      return this.isReverse ? date2.getTime() - date1.getTime() : date1.getTime() - date2.getTime();
    });
  }
  openChangeStatusModal(invoice: any) {
  this.selectedInvoice = invoice;
  this.changeStatusModel = true;
}
cancelChange() {
  this.changeStatusModel = false;
  this.selectedInvoice = null;
}
changeStatus(invoice: any) {
  const message = `Are you sure you want to change the invoice status from Raised to Collected?`;

  const dialogRef = this.dialog.open(ConfirmDialogComponent, {
    width: '400px',
    data: { title: 'Confirmation', message: message }
  });
  dialogRef.afterClosed().subscribe((result: any) => {
    //console.log('Dialog result:', result);
    if (result) {
      this.spinnerService.show();

      // STEP 1: GET Invoice Data
      this.httpservice.sendGetRequest(URLUtils.InvoiceWithId(invoice.id))
        .subscribe((res: any) => {
          //console.log('Fetched Invoice Data:', res);
          if (res.error === false) {

            // STEP 2: Modify status
            const updatedInvoice = { ...res.data, status: 'collected' };

            // STEP 3: CALL PUT to update invoice
            this.httpservice.sendPatchRequest(URLUtils.InvoiceWithId(invoice.id), updatedInvoice)
              .subscribe((updateRes: any) => {
                //console.log('Update Response:', updateRes);
                this.spinnerService.hide();

                if (!updateRes.error) {
                  this.toast.success("Invoice status successfully updated!");
                  invoice.status = 'collected'; // Update UI instantly
                } else {
                  this.toast.error(updateRes.msg);
                }
              },
                (error: HttpErrorResponse) => {
                  this.spinnerService.hide();
                  this.toast.error("Failed to update invoice.");
                });

          } else {
            this.spinnerService.hide();
            this.toast.error(res.msg || "Invoice not found.");
          }
        },
          (error: HttpErrorResponse) => {
            this.spinnerService.hide();
            this.toast.error("Failed to fetch invoice data.");
          });
    }
  });

  // this.confirmationDialogService
  //   .confirm('Confirmation', message, true, 'Yes', 'No')
  //   .then((confirmed) => {
  //     if (!confirmed) return;

  //     this.spinnerService.show();

  //     // STEP 1: GET Invoice Data
  //     this.httpservice.sendGetRequest(URLUtils.InvoiceWithId(invoice.id))
  //       .subscribe((res: any) => {
  //         console.log('Fetched Invoice Data:', res);
  //         if (res.error === false) {

  //           // STEP 2: Modify status
  //           const updatedInvoice = { ...res.data, status: 'collected' };

  //           // STEP 3: CALL PUT to update invoice
  //           this.httpservice.sendPatchRequest(URLUtils.InvoiceWithId(invoice.id), updatedInvoice)
  //             .subscribe((updateRes: any) => {
  //               console.log('Update Response:', updateRes);
  //               this.spinnerService.hide();

  //               if (!updateRes.error) {
  //                 this.toast.success("Invoice status successfully updated!");
  //                 invoice.status = 'collected'; // Update UI instantly
  //               } else {
  //                 this.toast.error(updateRes.msg);
  //               }
  //             },
  //             (error: HttpErrorResponse) => {
  //               this.spinnerService.hide();
  //               this.toast.error("Failed to update invoice.");
  //             });

  //         } else {
  //           this.spinnerService.hide();
  //           this.toast.error(res.msg || "Invoice not found.");
  //         }
  //       },
  //       (error: HttpErrorResponse) => {
  //         this.spinnerService.hide();
  //         this.toast.error("Failed to fetch invoice data.");
  //       });
  //   });
}

}